import { t } from "i18next";
import { LogOut } from "lucide-react";
import { getFromLocalStorage } from "neetocommons/utils";
import { resetAuthTokens } from "neetocommons/utils/axios";
import { removeFromLocalStorage } from "neetocommons/utils/general";
import { mergeDeepLeft } from "ramda";

import { THEMES, LEGACY_THEMES, APP_THEME_LOCALSTORAGE_KEY } from "./constants";

const getSidebarStateLocalStorageKey = () => {
  const user = globalProps.user?.email || globalProps.user?.phoneNumber;

  return `sidebarState-${user}`;
};

const getUserProfileInfo = () => ({
  name: `${globalProps.user?.firstName ?? ""} ${
    globalProps.user?.lastName ?? ""
  }`,
  imageUrl: globalProps.authenticated
    ? globalProps.user?.profileImageUrl
    : "https://d2v7kzglnr2dnh.cloudfront.net/others/profile-pic.jpg",
  email: globalProps.user?.email || globalProps.user?.phoneNumber,
  isAuthenticated: globalProps.authenticated,
});

const getConsumerProfileInfo = () => ({
  name: `${globalProps.consumer?.firstName ?? ""} ${
    globalProps.consumer?.lastName ?? ""
  }`,
  imageUrl:
    globalProps.consumer?.profileImageUrl ||
    "https://d2v7kzglnr2dnh.cloudfront.net/others/profile-pic.jpg",
  email: globalProps.consumer?.email || globalProps.consumer?.phoneNumber,
  isAuthenticated: globalProps.isConsumer,
});

export const getDefaultBottomLinks = (isAuthenticated, isConsumer) => [
  isAuthenticated
    ? {
        label: t("neetoMolecules.sidebar.logout"),
        icon: LogOut,
        onClick: () => {
          resetAuthTokens();
          removeFromLocalStorage(getSidebarStateLocalStorageKey());
          isConsumer
            ? (window.location.href = `/consumers/logout?redirect_uri=${window.location.href}`)
            : (window.location.href = "/logout");
        },
        "data-testid": "profile-logout-button",
      }
    : {
        label: t("neetoMolecules.sidebar.login"),
        onClick: () => {
          window.location.href = "/login";
        },
        "data-testid": "profile-login-button",
      },
];

export const getProfileInfo = (profileInfoOverrides, isConsumer) =>
  mergeDeepLeft(
    profileInfoOverrides,
    isConsumer ? getConsumerProfileInfo() : getUserProfileInfo()
  );

// Theme switcher utils.
export const setDarkTheme = () => {
  if (!document.body) return;

  document.body.classList.remove(THEMES.LIGHT, LEGACY_THEMES.LIGHT);
  document.body.classList.add(THEMES.DARK, LEGACY_THEMES.DARK);
};

export const setLightTheme = () => {
  if (!document.body) return;

  document.body.classList.remove(THEMES.DARK, LEGACY_THEMES.DARK);
  document.body.classList.add(THEMES.LIGHT, LEGACY_THEMES.LIGHT);
};

export const setAppTheme = () => {
  const storedTheme = getFromLocalStorage(APP_THEME_LOCALSTORAGE_KEY);
  const isDarkTheme =
    storedTheme === THEMES.DARK || storedTheme === LEGACY_THEMES.DARK;
  isDarkTheme ? setDarkTheme() : setLightTheme();
};
